module.exports = __webpack_public_path__ + "static/media/dumonde.bddcc261.jpg";